import { Response } from '@models/performance/response.model';

export class SurveyResponse extends Response {
    protected static _resource = 'performanceManagement/surveys/:survey/surveyResponses';
}
